<template>
  <div
    class="social-navbar flex pt-1 justify-center"
    :class="{ 'home-styling': isHome }"
  >
    <a
      class="m-1"
      href="https://open.spotify.com/artist/3xrbKno8shx3H22Xz8omC8?si=-ErxmcGVSQiUQrkaQ_ttbg"
      target="_blank"
      rel="noopener"
    >
      <i class="fab fa-spotify text-neutral-content" :class="size"></i>
    </a>
    <a
      class="m-1"
      href="https://music.apple.com/us/artist/sqwerv/1564277335"
      target="_blank"
      rel="noopener"
    >
      <i class="fab fa-apple text-neutral-content" :class="size"></i>
    </a>
    <a
      class="m-1"
      href="https://www.facebook.com/Sqwerv"
      target="_blank"
      rel="noopener"
    >
      <i class="fab fa-facebook-square text-neutral-content" :class="size"></i>
    </a>
    <a
      class="m-1"
      href="https://www.youtube.com/channel/UCtbI8FWG4a1As9wx1E4pYyQ"
      target="_blank"
      rel="noopener"
    >
      <i class="fab fa-youtube text-neutral-content" :class="size"></i>
    </a>
    <a class="m-1" href="https://www.instagram.com/sqwerv/" target="_blank">
      <i class="fab fa-instagram text-neutral-content" :class="size"></i>
    </a>
    <a class="m-1" href="https://sqwerv.bandcamp.com/" target="_blank">
      <i class="fab fa-bandcamp text-neutral-content" :class="size"></i>
    </a>
  </div>
</template>

<script setup>
defineProps({
  size: {
    type: String,
    default: 'fa-2x',
  },
  isHome: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.home-styling {
  flex-direction: column;
  bottom: 2%;
  position: absolute;
  right: 1%;
}
</style>
